import { User } from '../../../../../../models/interfaces/User.interface';
import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import { ProductCategory } from '../../../../../../models/interfaces/ProductCategory.interface';
import React from 'react';
import ProductTableComponent from '../../components/product-table/product-table.component';
import { Link, useOutletContext } from 'react-router-dom';
import routeService from '../../../../../../routes/route.service';

export default function ProductListComponent() {
  const { user, businessObject, category } = useOutletContext<{
    user: User;
    businessObject: BusinessObject;
    category: ProductCategory;
  }>();

  return (
    <div>
      <ProductTableComponent
        userId={user?.id}
        businessObjectId={businessObject?.id}
        categoryId={category?.id}
        products={category?.products}
      ></ProductTableComponent>

      <div>
        <Link to={routeService.getAndFillCategoryDetailPath(user?.id, businessObject?.id, category?.id)}>
          Back to category
        </Link>
      </div>
    </div>
  );
}
